import dropRight from './dropRight';

/**
 * Gets all but the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.initial([1, 2, 3]);
 * // => [1, 2]
 */
function initial(array) {
  return dropRight(array, 1);
}

export default initial;



//////////////////
// WEBPACK FOOTER
// ../ckeditor5-utils/src/lib/lodash/initial.js
// module id = 209
// module chunks = 0